export const PILL_CONTRACT_LOGOS = {
  "eos-mainnet": [
    {
      contract: "zswhq.token",
      path: "/images/pill-logos/logo-contract-eos-01.svg",
      website: "https://zhongshuwen.com"
    },
    {
      contract: "zswhq",
      path: "/images/pill-logos/logo-contract-eos-01.svg",
      website: "https://zhongshuwen.com",
      action: "onblock"
    },
  ]
}

export const ACCOUNT_CREATORS = {
  "eos-mainnet": [
    {
      contract: "accountcreat",
      website: "https://zhongshuwen.com",
      path: "/images/pill-logos/logo-contract-eos-account-creator-01.svg"
    },
  ]
}
